<template>
    <div class="normal-container pt-10">
        <div :class="['flex', 'flex-col', 'items-center', AlignmentClass, { 'big-title': bigTitle }]">
            <div class="sanity-content content-sanity-content" :class="WidthClass">
                <SanityContent :blocks="body" :serializers="serializers" />
            </div>
        </div>
    </div>
</template>

<script setup>
    import { extractFaqFromPortableText } from '~/utils/seo';

    const props = defineProps({
        title: String,
        body: {
            type: [String, Object],
            required: true,
        },
        alignContent: {
            type: String,
            default: 'center',
        },
        bigTitle: Boolean,
        sizeBlock: {
            type: String,
            default: 'medium',
        },
    });

    useFaqPageSchema(() => extractFaqFromPortableText(props.body));

    const AlignmentClass = computed(() => {
        switch (props.alignContent) {
            case 'left':
                return 'text-left';
            case 'right':
                return 'text-right';
            case 'center':
                return 'text-center';
            default:
                return 'text-center';
        }
    });

    const WidthClass = computed(() => {
        switch (props.sizeBlock) {
            case 'small':
                return 'lg:!w-[466px]';
            case 'medium':
                return 'lg:!w-[775px]';
            case 'large':
                return 'lg:!w-[860px]';
            default:
                return 'w-full';
        }
    });

    const serializers = {
        types: {
            button: resolveComponent('Button'),
            spacing: resolveComponent('BlockSpacing'),
            VideoImage: resolveComponent('BlockVideoImage'),
            RawHtml: resolveComponent('BlockRawHtml'),
        },
    };
</script>
